import React from 'react';

const TestimonialPage = React.lazy(() => import('pages/Testimonial/TestimonialPage'));
const TestimonialAddPage = React.lazy(() => import('pages/Testimonial/TestimonialAddPage'));

const TestimonialRoute = [
  {
    path: '/testimonial',
    exact: true,
    name: 'Danh sách cảm nhận KH',
    function: 'CMS_TESTIMONIAL_VIEW',
    component: TestimonialPage,
  },
  {
    path: '/testimonial/add',
    exact: true,
    name: 'Thêm mới cảm nhận KH',
    function: 'CMS_TESTIMONIAL_ADD',
    component: TestimonialAddPage,
  },
  {
    path: '/testimonial/edit/:testimonial_id',
    exact: true,
    name: 'Chỉnh sửa cảm nhận KH',
    function: 'CMS_TESTIMONIAL_EDIT',
    component: TestimonialAddPage,
  },
  {
    path: '/testimonial/detail/:testimonial_id',
    exact: true,
    name: 'Chi tiết cảm nhận KH',
    function: 'CMS_TESTIMONIAL_VIEW',
    component: TestimonialAddPage,
  },
];

export default TestimonialRoute;
